import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/admin/pages/Dashboard'
import { AdminRoutePathsEnum } from '@/modules/admin/routes/adminRouteConfig.types'

export const ADMIN_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: AdminRoutePathsEnum.DASHBOARD,
  },
]
